import firebase from 'firebase'


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
    apiKey: "AIzaSyCQYQpKqi2Afl7lDCxASnM64aLgO6vFomc",
    authDomain: "ritsbook-997bf.firebaseapp.com",
    projectId: "ritsbook-997bf",
    databaseURL: "https://ritsbook-997bf-default-rtdb.firebaseio.com",
    storageBucket: "ritsbook-997bf.appspot.com",
    messagingSenderId: "1021330034131",
    appId: "1:1021330034131:web:a05a30434f15df355bf326",
    measurementId: "G-TL6NXR5263"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  export default firebase